import React from "react";
import { VideoPlayer } from "../components/VideoPlayer";
import styles from "./PresseArtikelRecken.module.css";

export default function PresseArtikelRecken() {
  const navigate = (event: React.MouseEvent) => {
    event.preventDefault();
    window.history.pushState({}, "", "/presse");
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  return (
    <section className={styles.article}>
      <a href="/presse" onClick={navigate} className={styles.back}>
        ← Zurück zur Presse
      </a>

      <div className={styles.videoSection}>
        <VideoPlayer
          videoUrl="/videos/presse/DUOday%20meets%20Recken.mp4"
          title="DUOday meets Recken"
        />
      </div>

      <p className={styles.source}>Recken-Bote | SC DHfK Leipzig | Saison 2025/2026</p>
      <h1 className={styles.title}>DUOday bringt gelebte Inklusion in den Arbeitsalltag</h1>

      <div className={styles.text}>
        <p>
          Der DUOday setzt ein sichtbares Zeichen für Inklusion und Teilhabe am
          Arbeitsleben. Beim inklusiven Aktionstag bilden Menschen mit
          Behinderungen und Mitarbeitende aus Unternehmen und Institutionen für
          einen Tag ein sogenanntes DUO. Ziel ist es, Berührungsängste
          abzubauen und neue berufliche Perspektiven zu eröffnen.
        </p>

        <p>
          In Hannover und der Region bietet der DUOday nun im zweiten Jahr in
          Folge Menschen mit Behinderungen die Möglichkeit, den allgemeinen
          Arbeitsmarkt kennenzulernen und unterschiedliche Berufsfelder direkt
          im Arbeitsalltag zu erleben. Ob Verwaltung, Technik, Kundenservice
          oder Organisation – die Teilnehmenden begleiten am 20. Mai ihre
          DUO-Partner:innen einen Tag lang, wirken aktiv mit und erhalten
          authentische Einblicke in betriebliche Abläufe. Gleichzeitig
          gewinnen die beteiligten Unternehmen wertvolle Erfahrungen im
          inklusiven Arbeiten und lernen neue Perspektiven und Potenziale
          kennen.
        </p>

        <p>
          Initiiert und organisiert wird der DUOday von enercity. Gemeinsam
          mit der Stadt Hannover und der Region Hannover übernimmt das
          Energieunternehmen die Schirmherrschaft für den Aktionstag. Damit
          setzen die drei Partner ein gemeinsames Zeichen für eine offene,
          vielfältige und inklusive Arbeitswelt in Stadt und Region.
        </p>

        <p>
          Der DUOday versteht sich bewusst nicht als Bewerbungs- oder
          Leistungsformat. Im Mittelpunkt steht das gemeinsame Erleben, der
          persönliche Austausch und das gegenseitige Kennenlernen. Der
          Aktionstag schafft Raum für echte Begegnungen, ermöglicht neue
          Sichtweisen und trägt dazu bei, Vorurteile abzubauen. Für viele
          Teilnehmende entstehen daraus neue Impulse – für weitere Gespräche,
          Praktika oder langfristige berufliche Perspektiven. Das Datum für
          den dritten DUOday steht auch bereits fest, es ist der 26. Mai 2027.
        </p>
      </div>

      <img
        src="/Screenshot 2026-10-04 132351.png"
        alt="Recken-Bote Artikel: DUOday bringt gelebte Inklusion in den Arbeitsalltag"
        className={styles.photo}
      />
    </section>
  );
}
